import { useRecoilValue } from "recoil";
import { Box, Grid, Stack } from "@mui/joy";
import React, { useCallback, useEffect, useState } from "react";
import { patientAtom } from "recoil/patientAtom";
import {
  DASHBOARD_DETAIL_ENDPOINT,
  DASHBOARD_DOMAIN,
  dashboardApi,
  DashboardType,
} from "api/dashboardApi";
import { useQuery } from "@tanstack/react-query";
import { getExtraAutomaticThoughtKey } from "logic/logics";
import ThoughtMap from "components/thoughtmap/ThoughtMap";
import ContentTemplateV2 from "../content/ContentTemplateV2";

function Section({ content }: { content: React.ReactNode }) {
  return <Box sx={{ height: "100%" }}>{content}</Box>;
}

export default function MyThoughtMapContent() {
  const patientState = useRecoilValue(patientAtom);

  const loadDashboardQueryFn = useCallback(
    () => dashboardApi.load(patientState?.patientId!!),
    [patientState?.patientId]
  );

  const blankDashboardData = {
    concept: {},
    history: {},
    selfCheckResult: {},
  };
  const [dashboardData, setDashboardData] = useState<DashboardType>();
  useQuery(
    [DASHBOARD_DOMAIN, DASHBOARD_DETAIL_ENDPOINT, patientState?.patientId],
    loadDashboardQueryFn,
    {
      enabled: !!patientState?.patientId,
      onSuccess: (data) => {
        console.log("[TEST] dashboard data:", data.result);
        setDashboardData(data.result);
      },
    }
  );

  useEffect(() => {
    if (!patientState?.patientId) {
      setDashboardData(blankDashboardData);
    }
  }, [patientState]);

  return (
    <ContentTemplateV2>
      <Stack spacing={2}>
        {dashboardData && (
          <Stack spacing={2}>
            <Grid
              container
              spacing={2}
              alignItems="stretch"
              sx={{ flexGrow: 1, width: "100%" }}
            >
              <Grid xs={12} sx={{ p: 0 }}>
                <Section
                  content={
                    <ThoughtMap
                      data={{
                        ...dashboardData?.concept,
                        [getExtraAutomaticThoughtKey(dashboardData?.concept)]:
                          undefined,
                      }}
                      includeAutomaticThoughtDetail={true}
                    />
                  }
                />
              </Grid>
            </Grid>
          </Stack>
        )}
      </Stack>
    </ContentTemplateV2>
  );
}
